const CHAT_WINDOW_TOP_GAP = 8;
const CHAT_WINDOW_TOP_FALLBACK = 170;

export const getCtxBarElement = (): HTMLElement | null =>
	document.querySelector(".ctxbar--classroomPage") ?? document.querySelector(".ctxbar");

export const getChatWindowTopPosition = (): number => {
	const ctxBar = getCtxBarElement();
	if (ctxBar) {
		return ctxBar.getBoundingClientRect().bottom + CHAT_WINDOW_TOP_GAP;
	}
	return CHAT_WINDOW_TOP_FALLBACK;
};
